const apiUrl =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development'
    ? 'https://localhost:5001/api'
    : `${window.location.origin}/api`);
const adClientId = process.env.REACT_APP_AD_CLIENT_ID || 'e856bd91-ef6d-4e36-994e-3d689d8c210e';
const adTenantId = process.env.REACT_APP_AD_TENANT_ID || '701e51de-6b7f-4401-8ae0-57c9588cdd68';
const adScope = process.env.REACT_APP_AD_SCOPE || '30922561-6a73-4b1f-b826-0c3f83d5c225/user_scope';
export { apiUrl, adClientId, adTenantId, adScope, };
